import { Injectable } from "@angular/core";
import { Observable ,  Subject } from "rxjs";
import { NotifierService } from "./notifierService/notifier.service";
import { ModalPopupService } from "app/services/modal-popup.service";
import { TrackingManager } from "app/core/tracking/tracking-manager";
import { Scorm } from "app/core/tracking/scorm";
import { AICC } from "app/core/tracking/aicc";
import { Disabled } from "app/core/tracking/disabled";
import { AppConstants } from "../core/vo/app-constants";
import { UtilityScripts } from "app/helpers/utility-scripts";
import { DescriptorModelService } from "app/core/models/descriptor-model.service";
import { ScreenControllerService } from "app/core/controls/screen-controller.service";
import { AppServices } from "app/app.services";
import { CMI5 } from "../core/tracking/cmi5";
import { XAPI } from "app/core/tracking/xapi";
import { ConfigJsonModelService } from "app/core/models/config-json-model.service";

@Injectable()
export class ApplicationUtilityService extends NotifierService {
	public isPlayerWindowUnloaded = false;
	private popupdata: any;
	constructor(
		private popupService: ModalPopupService,
		private descriptorService: DescriptorModelService,
		private screenController: ScreenControllerService,
		private appServices: AppServices,
		private configJsonModel: ConfigJsonModelService
	) {
		super();
		this.popupdata = {
			size: "lg",
			footer: UtilityScripts.removeHTMLTags(
				this.descriptorService.getDescriptorTextById("exitFooter")
			),
			title: UtilityScripts.removeHTMLTags(
				this.descriptorService.getDescriptorTextById("exitHeader")
			),
			body: UtilityScripts.removeHTMLTags(
				this.descriptorService.getDescriptorTextById("exitBody")
			),
		};
	}
	public async exitCourse() {
		TrackingManager.instance.saveData(true);
		if (TrackingManager.instance.trackingObj instanceof Scorm) {
			await TrackingManager.instance.trackingObj.doFinish();
			const closeSuccess: Boolean =
				await TrackingManager.instance.trackingObj.lmsFinish();
			console.log("LMSFinish return value ", closeSuccess);
			if (closeSuccess) {
				//this.popupService.openDialogPopup(popupdata);
				this.isPlayerWindowUnloaded = true;
				this._notifier.next("exitCourse");
				this.closePlayerAndLaunchWindow();
			} else {
				this.exitError();
			}
		} else if (TrackingManager.instance.trackingObj instanceof AICC) {
			AppConstants.isExiting = true;
			TrackingManager.instance.trackingObj.doFinish();
			this.closePlayerAndLaunchWindow();
		} else if (
			TrackingManager.instance.trackingObj instanceof XAPI ||
			TrackingManager.instance.trackingObj instanceof CMI5
		) {
			const closeSuccess =
				await TrackingManager.instance.trackingObj.doFinish();
			//const closeSuccess = TrackingManager.instance.trackingObj.exitCourse();
			if (TrackingManager.instance.trackingObj instanceof XAPI) {
				if (closeSuccess) this.closePlayerAndLaunchWindow();
				else this.exitError();
			} else {
				this.popupService.openDialogPopup(this.popupdata);
			}
		} else if (TrackingManager.instance.trackingObj instanceof Disabled) {
			this.closePlayerAndLaunchWindow();
		}
	}
	public pauseCoursePlayer() {
		this.appServices.pauseAudio();
		this.appServices.pauseVideo();
	}
	public closePlayerAndLaunchWindow() {
		this.popupService.openDialogPopup(this.popupdata);
		setTimeout(() => {
			let objParams: any = UtilityScripts.getConfigDetailsFromLocation(
				document.location.search.substr(1).split("&")
			);
			let launchType = objParams.launchType ? objParams.launchType : "";
			this.isPlayerWindowUnloaded = true;
			const isTopWindow = window.parent.location.href === window.location.href;
			const closeOnlyIfTop =
				TrackingManager.instance.trackingObj instanceof Scorm;
			const canBeClosedIfNotTop = !closeOnlyIfTop;
			const usesCustomLaunchOpener =
				(launchType == "tab" || launchType == "window") &&
				opener &&
				opener.closeLaunchWindow;
			if (usesCustomLaunchOpener) {
				opener.closeLaunchWindow();
			} else if ((closeOnlyIfTop && isTopWindow) || canBeClosedIfNotTop) {
				window.parent.close();
			} else {
				//Need code to display some sort of popup message indicating course
				// session has ended.
				let forceClose =
					typeof this.configJsonModel.configData["forceClose"] == "boolean"
						? this.configJsonModel.configData["forceClose"]
						: typeof this.configJsonModel.configData["forceClose"] == "string"
						? this.configJsonModel.configData["forceClose"].toLowerCase() ==
						  "true"
							? true
							: false
						: false;
				if (forceClose) {
					window.close();
					top.close();
					opener.close();
				}
				alert(
					"Your progress is being recorded to the learning management system."
				);
			}
		}, 1000);
	}
	private exitError() {
		alert("Some error occured. Please contact your LMS Administrator.");
	}
}
